import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { LogOut, User } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_friseur-booking/artifacts/mtmj2lif_IMG_5702.PNG" 
              alt="Salon Galo Logo" 
              className="h-16 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link
              to="/gallery"
              className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              data-testid="nav-gallery"
            >
              Galerie
            </Link>
            <Link
              to="/angebote"
              className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              data-testid="nav-offers"
            >
              Abos & Gutscheine
            </Link>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            <Button
              onClick={() => navigate('/angebote')}
              variant="ghost"
              size="sm"
              className="md:hidden text-xs text-blue-700"
              data-testid="mobile-offers"
            >
              Angebote
            </Button>
            {user ? (
              <div className="flex items-center space-x-3">
                <Button
                  onClick={() => navigate('/profile')}
                  variant="ghost"
                  size="sm"
                  className="flex items-center space-x-2 text-slate-600 hover:text-blue-600"
                  data-testid="profile-nav-button"
                >
                  <User className="w-5 h-5" />
                  <span className="text-sm font-medium">{user.name}</span>
                </Button>
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  size="sm"
                  className="text-slate-600 hover:text-blue-600"
                  data-testid="logout-button"
                >
                  <LogOut className="w-4 h-4" />
                </Button>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Button
                  onClick={() => navigate('/login')}
                  variant="ghost"
                  size="sm"
                  className="text-slate-600 hover:text-blue-600"
                  data-testid="login-nav-button"
                >
                  Login
                </Button>
                <Button
                  onClick={() => navigate('/register')}
                  className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6"
                  size="sm"
                  data-testid="register-nav-button"
                >
                  Registrieren
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
